require('./bootstrap');

$('.navbar-toggler').on('click', function () {
  $(this).toggleClass('is-active');
  $('.navbar-collapse.show[id]').each(function () {
    $('.navbar-toggler.is-active[data-target="#' + $(this).attr('id') + '"]').click();
  });
});

$('.btn-subscribe').on('click', function (e) {
  e.preventDefault();

  let subscribe = true;
  this.name = $('#newsletter-subscribe #name').val();
  this.email = $('#newsletter-subscribe #email').val();
  this.terms = $('#newsletter-subscribe #terms').is(':checked');

  if (!this.name) {
    $('.name.error-message').html('Please enter your name.');
    subscribe = false;
  } else {
    $('.name.error-message').html('');
    subscribe = true;
  }

  if (!this.email) {
    $('.email.error-message').html('Please enter your E-mail address.');
    subscribe = false;
  } else {
    $('.email.error-message').html('');
    subscribe = true;
  }

  if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.email) != true) {
    $('.email.error-message').html('Please enter a valid E-mail address.');
    subscribe = false;
  }

  if (!this.terms) {
    $('.terms.error-message').html('Please accept our Privacy Policy.');
    subscribe = false;
  } else {
    $('.terms.error-message').html('');
    subscribe = true;
  }

  if (!subscribe) return false;

  $.ajax({
    type: 'POST',
    url: '/newsletter-subscribe',
    headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
    data: {
      name: this.name,
      email: this.email,
      terms: this.terms,
    },
  }).then((response) => {
    if (response.error) {
      $('.response-status').html('The newsletter subscribe unsuccessful. Please try again later.').addClass('p-3');
    } else {
      location.href = '/newsletter/success';
    }
  });
});

$(document).ready(function () {
  //Recipe search
  $("#recipe-search-form").on('change', function () {
    $('#recipe-search-form').trigger('submit');
  });

  //About us
  $(".korostejkft").on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $("#korostejkft").offset().top - 300
    });
  });

  $(".hajdusuperbrand").on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $("#hajdusuperbrand").offset().top - 300
    });
  });

});
